import { Navigate } from "react-router-dom";
import { useUsers } from "../../api/users";
import { Badge } from "../../components/ui/Badge";
import { Page } from "../../components/ui/Page";
import PageLoader from "../../components/ui/PageLoader";
import { Table } from "../../components/ui/Table";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import { useLayoutTitle } from "../../hooks/useLayoutTitle";
import { useTranslation } from "../../hooks/useTranslation";
import styles from "./AdminPage.module.css";

export default function AdminPage() {
  const { t, language } = useTranslation();
  useLayoutTitle(t("admin.title"));
  const currentUser = useCurrentUser();
  const { data: usersPage, isLoading: usersLoading } = useUsers();
  const users = usersPage?.data ?? [];

  if (!currentUser.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <Page>
      <div className={styles["alertInfo"]}>{t("admin.noAdminEndpoint")}</div>

      {usersLoading ? (
        <PageLoader />
      ) : (
        <Table>
          <Table.Head>
            <Table.HeaderCell>{t("admin.name")}</Table.HeaderCell>
            <Table.HeaderCell>{t("admin.email")}</Table.HeaderCell>
            <Table.HeaderCell>{t("admin.isAdmin")}</Table.HeaderCell>
            <Table.HeaderCell>{t("admin.managerId")}</Table.HeaderCell>
            <Table.HeaderCell>{t("admin.createdAt")}</Table.HeaderCell>
          </Table.Head>
          <Table.Body>
            {users.map((u) => (
              <Table.Row key={u.id}>
                <Table.Cell variant="strong">
                  {u.firstName} {u.lastName}
                </Table.Cell>
                <Table.Cell variant="muted">{u.email}</Table.Cell>
                <Table.Cell>
                  {u.isAdmin ? (
                    <Badge variant="completed" label={t("common.yes")} />
                  ) : (
                    <Badge variant="default" label={t("common.no")} />
                  )}
                </Table.Cell>
                <Table.Cell variant="muted">
                  {u.manager ? `${u.manager.firstName} ${u.manager.lastName}` : "—"}
                </Table.Cell>
                <Table.Cell variant="muted">{new Date(u.createdAt).toLocaleDateString(language)}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Page>
  );
}
